import { GetAllBones as x, uuidV4 as y, RG_TYPE as d } from "@project-rouge/rg-core";
import { getConnectedBonesAtLevel as B } from "./index.js";
const A = (r, g) => {
  const p = r.children, u = x(r.data.anatomy), a = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  for (const e of u) {
    m.set(e.tendon.id, e), n.has(e.joints[0].id) || n.set(e.joints[0].id, []), n.get(e.joints[0].id).push(e), n.has(e.joints[1].id) || n.set(e.joints[1].id, []), n.get(e.joints[1].id).push(e);
    for (const o of e.muscles)
      a.set(o.id, e);
  }
  const f = Array.from(new Set(p.map((e) => e.pos[1]))).sort((e, o) => e - o), b = new Map(f.map((e, o) => [e, o])), s = [];
  for (let e = 0; e < f.length; e++) {
    const o = f[e], l = [];
    s.push(l);
    for (const i of u) {
      if (i.floors <= e || l.some((t) => t.bones.includes(i.id)))
        continue;
      const v = B(i, e), h = {
        uuid: y(),
        floorWorldBottom: o,
        levelConfig: g,
        levelIndex: e,
        bones: v.map((t) => t.id)
      };
      l.push(h);
    }
  }
  r.data.levels = s.flat();
  for (const e of p) {
    const o = I(e);
    e.data.level = o.levelIndex, e.data.levelId = o.uuid;
  }
  function I(e) {
    if (e.type === d.EmptySpace)
      return s[0][0];
    if (e.type === d.Roof)
      return s[s.length - 1][0];
    let o = [];
    if (e.type === d.Core) {
      const t = n.get(e.data.jointID);
      t && o.push(...t);
      const c = a.get(e.data.muscleID);
      c && o.push(c);
    } else if (e.type === d.Corridor) {
      const t = m.get(e.data.tendonID);
      t && o.push(t);
    } else if ("muscleID" in e.data) {
      const t = a.get(e.data.muscleID);
      t && o.push(t);
    }
    const l = b.get(e.pos[1]);
    if (o = o.filter((t) => t.floors >= l), !o.length)
      throw new Error("expected all children to be on bones");
    const i = o.map((t) => t.id);
    return s[l].find((t) => i.some((c) => t.bones.includes(c)));
  }
};
export {
  A as setLevelData
};
//# sourceMappingURL=index3.js.map
